import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Member, UpdateMember } from "@/model";
import memberRepository from "@/repository/memberRepository";
import { permissionQueryKeys } from "@/query/permission";
import { memberQueryKeys } from "./keys";


export const useUpdateMember = (scenarioId: string) => {
    const queryClient = useQueryClient();

    return useMutation<Member, AxiosError, UpdateMember>({
        mutationKey: ["member", "update"],
        mutationFn: async (form: UpdateMember) => {
            try {
                if (!form.member_id) {
                    return;
                }
                const { data } = await memberRepository.update(scenarioId, form.member_id, form);
                return data.result;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.refetchQueries({ queryKey: permissionQueryKeys.me(scenarioId) }),
                queryClient.invalidateQueries({ queryKey: memberQueryKeys.all(scenarioId) })
            ]);
        }
    });
};
